<template>
  <ResultForm :data="lotto" :isNew="true" :isLoading="isLoading" @save="save"></ResultForm>
</template>
<script>
import LottoService from "@/services/lottoService"

import moment from "moment"

import ResultForm from "./ResultForm.vue"

export default {
  components: {
    ResultForm
  },
  data() {
    return {
      lotto: {
        lotto_date: moment().add(-5, 'h').format("YYYY-MM-DD"),
        start_spin: '',
        show_1st: '',
        show_2nd: '',
        results: {
          prize_1st: '',
          prize_2nd: '',
          prize_3rd_1: LottoService.randomNumber(5),
          prize_3rd_2: LottoService.randomNumber(5),
          prize_3rd_3: LottoService.randomNumber(5),
          special_1: LottoService.randomNumber(5),
          special_2: LottoService.randomNumber(5),
          special_3: LottoService.randomNumber(5),
          special_4: LottoService.randomNumber(5),
          special_5: LottoService.randomNumber(5),
          special_6: LottoService.randomNumber(5),
          special_7: LottoService.randomNumber(5),
          special_8: LottoService.randomNumber(5),
          consolation_1: LottoService.randomNumber(2),
          consolation_2: LottoService.randomNumber(2),
          consolation_3: LottoService.randomNumber(2),
          consolation_4: LottoService.randomNumber(2)
        }
      },
      isLoading: false
    }
  },
  methods: {
    save(data) {
      this.isLoading = true
      LottoService.saveResult(data)
      .then((response) => {
        try {
          if (response.status === 'success') {
            this.$vs.notify({
              title: 'สำเร็จ!',
              text: 'บันทึกผลหวยเสร็จเรียบร้อย',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            });

            this.$router.push({ name: 'admin-results' })
          } else {
            this.$vs.notify({
              title: 'ผิดพลาด!',
              text: 'บันทึกผลหวยไม่สำเร็จ',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          }
        } catch (e) {
          //console.log(e)
          this.$vs.notify({
            title: 'ผิดพลาด(2)!',
            text: 'บันทึกผลหวยไม่สำเร็จ',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      })
      .finally(()=>{
        this.isLoading = false
      })
    }
  },
  mounted() {
    this.lotto.start_spin = moment(this.lotto.lotto_date).add(1, 'd').format("YYYY-MM-DD 01:05")
    this.lotto.show_1st = moment(this.lotto.lotto_date).add(1, 'd').format("YYYY-MM-DD 01:30")
    this.lotto.show_2nd = moment(this.lotto.lotto_date).add(1, 'd').format("YYYY-MM-DD 01:15")
  }
}

</script>
